import apiService from './ApiService';

class SolicitudesService {
  constructor() {
    this.apiService = apiService;
  }

  async crearSolicitudGptClasico(formData) {
    return this.apiService.request('/solicitudes', {
      method: 'POST',
      body: formData
    });
  }

  async getSolicitudesGptClasicos(options = {}) {
    const params = new URLSearchParams();
    if (Number.isFinite(options.start)) params.append('start', options.start);
    if (Number.isFinite(options.end)) params.append('end', options.end);
    if (options.scope) params.append('scope', options.scope);
    if (typeof options.esPropio === 'boolean') params.append('esPropio', String(options.esPropio));
    const query = params.toString();
    return this.apiService.request(`/solicitudes/gpt-clasicos${query ? `?${query}` : ''}`, {
      method: 'GET'
    });
  }

  async getMisSolicitudesGptClasicos({ skip = 0, take = 20 } = {}) {
    const params = new URLSearchParams();
    if (Number.isFinite(skip)) params.append('skip', skip);
    if (Number.isFinite(take)) params.append('take', take);
    const query = params.toString();
    const endpoint = query ? `/solicitudes/mis-gpt-clasicos?${query}` : '/solicitudes/mis-gpt-clasicos';
    return this.apiService.request(endpoint, {
      method: 'GET'
    });
  }

  async getSolicitudesRecibidasGptClasicos({ skip = 0, take = 20, search = '', leido = 'todos', tipo = 'todos', colegioId = null } = {}) {
    const params = new URLSearchParams();
    if (Number.isFinite(skip)) params.append('skip', skip);
    if (Number.isFinite(take)) params.append('take', take);
    if (search) params.append('search', search);
    if (leido) params.append('leido', leido);
    if (tipo) params.append('tipo', tipo);
    if (colegioId) params.append('colegioId', colegioId);
    const query = params.toString();
    const endpoint = query ? `/solicitudes/recibidas-gpt-clasicos?${query}` : '/solicitudes/recibidas-gpt-clasicos';
    return this.apiService.request(endpoint, {
      method: 'GET'
    });
  }

  async getSolicitudesRecibidasAcciones(id, colegioId) {
    if (!id) throw new Error('Solicitud inválida.');
    const params = new URLSearchParams();
    if (colegioId) params.append('colegioId', colegioId);
    const query = params.toString();
    const endpoint = query
      ? `/solicitudes/recibidas-gpt-clasicos/${id}/acciones?${query}`
      : `/solicitudes/recibidas-gpt-clasicos/${id}/acciones`;
    return this.apiService.request(endpoint, {
      method: 'GET'
    });
  }

  async downloadSolicitudArchivoAgregar(id, fileIndex, colegioId) {
    if (!id) throw new Error('Solicitud inválida.');
    if (!Number.isInteger(fileIndex) || fileIndex < 0) throw new Error('Archivo inválido.');
    const params = new URLSearchParams();
    if (colegioId) params.append('colegioId', colegioId);
    const query = params.toString();
    const url = `${this.apiService.baseURL}/solicitudes/recibidas-gpt-clasicos/${id}/archivos-agregar/${fileIndex}/download${query ? `?${query}` : ''}`;
    const headers = this.apiService.getAuthHeaders();
    const resp = await fetch(url, { headers });
    if (!resp.ok) throw new Error('No pudimos descargar el archivo.');
    return resp.blob();
  }

  async downloadSolicitudArchivosAgregarZip(id, colegioId) {
    if (!id) throw new Error('Solicitud inválida.');
    const params = new URLSearchParams();
    if (colegioId) params.append('colegioId', colegioId);
    const query = params.toString();
    const url = `${this.apiService.baseURL}/solicitudes/recibidas-gpt-clasicos/${id}/archivos-agregar/zip${query ? `?${query}` : ''}`;
    const headers = this.apiService.getAuthHeaders();
    const resp = await fetch(url, { headers });
    if (!resp.ok) throw new Error('No pudimos descargar el ZIP.');
    return resp.blob();
  }

  async updateSolicitudLeido(id, leido) {
    if (!id) throw new Error('Solicitud inválida.');
    return this.apiService.request(`/solicitudes/recibidas-gpt-clasicos/${id}/leido`, {
      method: 'PUT',
      body: { leido: Boolean(leido) }
    });
  }

  async deleteSolicitudRecibida(id, colegioId) {
    if (!id) throw new Error('Solicitud inválida.');
    const params = new URLSearchParams();
    if (colegioId) params.append('colegioId', colegioId);
    const query = params.toString();
    const endpoint = `/solicitudes/recibidas-gpt-clasicos/${id}${query ? `?${query}` : ''}`;
    return this.apiService.request(endpoint, {
      method: 'DELETE'
    });
  }

  async finalizarSolicitud(id, payload) {
    if (!id) throw new Error('Solicitud inválida.');
    return this.apiService.request(`/solicitudes/recibidas-gpt-clasicos/${id}/finalizar`, {
      method: 'PUT',
      body: payload
    });
  }
}

export default new SolicitudesService();
